import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class FiinTradeStrategyProxy extends ProxyBase {
  getValue(params) {
    return this.get('GetValue', params);
  }
  getMomentum(params) {
    return this.get('GetMomentum', params);
  }
  getGrowth(params) {
    return this.get('GetGrowth', params);
  }
  getVGM(params) {
    return this.get('GetVGM', params);
  }
  getLeaders(params) {
    return this.get('GetLeaders', params);
  }
  getValueInvestment(params) {
    return this.get('GetValueInvestment', params);
  }
  getOverView(params) {
    return this.get('GetOverView', params);
  }
  getCanSlim(params) {
    return this.get('GetCanSlim', params);
  }
  downloadScore(params) {
    return this.get('DownloadScore', params, null, 'download');
  }
  downloadCanSlim(params) {
    return this.get('DownloadCanSlim', params, null, 'download');
  }
}

const fiinTradeStrategyProxy = new FiinTradeStrategyProxy(
  ServiceProxyConfig.Stategy.Strategy.ServiceUrl,
);
export default fiinTradeStrategyProxy;
